import axios from 'axios';
import TokenAPI from './token';

class HttpClient {

    instance:any;

  constructor(baseURL:any) {
    this.instance = axios.create({
      baseURL
    });

    this._initializeResponseInterceptor();
  }

  _initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      this._handleResponse,
      this._handleError,
    );
  };

  _handleResponse = (data:any) => data;

  _handleError = async ({ response, config }:any) => {
    const originalRequest = config;
    if (response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const tokenAPI = new TokenAPI();

      // const result = await tokenAPI.getRefreshToken();
      // if (!result) {
      //   return Promise.resolve(response);
      // }
      // return Promise.resolve(response);
      // axios.defaults.headers.common.Authorization = `Bearer ${result}`;
      
      return this.instance(originalRequest);
    }

    return Promise.resolve(response);
  };
}

export default HttpClient;
